// ステータスバッジ (tone で色分け)。
// 既存の各画面で rounded bg-*-100 text-*-800 px-2 py-0.5 text-xs を手書き
// していた箇所を段階的にこれに置換していく。
import type { ReactNode } from "react";

export type BadgeTone =
  | "success"
  | "warning"
  | "danger"
  | "neutral"
  | "info"
  | "accent";

const TONE: Record<BadgeTone, string> = {
  success: "bg-green-50 text-green-700",
  warning: "bg-yellow-50 text-yellow-800",
  danger: "bg-red-50 text-tora",
  neutral: "bg-black/5 text-tora-ink/80",
  info: "bg-blue-50 text-blue-700",
  accent: "bg-tora/10 text-tora",
};

interface Props {
  tone?: BadgeTone;
  bold?: boolean;
  className?: string;
  children: ReactNode;
}

export function StatusBadge({
  tone = "neutral",
  bold,
  className,
  children,
}: Props) {
  return (
    <span
      className={`inline-block rounded-full px-3 py-1 text-xs ${TONE[tone]} ${
        bold ? "font-bold" : "font-medium"
      } ${className ?? ""}`.trim()}
    >
      {children}
    </span>
  );
}
